import IUser from 'interface/user/user-interface'

export const isNotCurrentUser = (
	{ securityInfo: { email } }: IUser,
	currentConnectedUser: IUser
) => email !== currentConnectedUser.securityInfo.email
